import React, { useState, useEffect } from 'react';
import './ThicknessPopup.css';

const ThicknessPopup = ({ isOpen, onClose, onSave, currentThickness = 5 }) => {
  const [thickness, setThickness] = useState(currentThickness);

  useEffect(() => {
    setThickness(currentThickness);
  }, [currentThickness]);

  const handleSave = () => {
    onSave(thickness);
    onClose();
  };

  const handleCancel = () => {
    setThickness(currentThickness);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="thickness-popup-overlay">
      <div className="thickness-popup">
        <h3>Adjust Wall Thickness</h3>
        <div className="thickness-control">
          <label htmlFor="thickness-slider">Thickness: {thickness}px</label>
          <input
            id="thickness-slider"
            type="range"
            min="1"
            max="20"
            value={thickness}
            onChange={(e) => setThickness(parseInt(e.target.value))}
            className="thickness-slider"
          />
          <div className="thickness-preview">
            <div 
              className="thickness-sample"
              style={{ 
                height: `${thickness}px`,
                backgroundColor: '#333',
                margin: '10px 0'
              }}
            ></div>
          </div>
        </div>
        <div className="thickness-buttons">
          <button onClick={handleCancel} className="cancel-btn">
            Cancel
          </button>
          <button onClick={handleSave} className="save-btn">
            Apply
          </button>
        </div>
      </div>
    </div>
  );
};

export default ThicknessPopup; 